import { useTranslation } from 'react-i18next'
import { Users } from 'lucide-react'
import { NewProjectCard } from './new-project-card'

interface EmptyStateProps {
  canCreateProject: boolean
  onCreateTeam: () => void
}

export function EmptyState({ canCreateProject, onCreateTeam }: EmptyStateProps) {
  const { t } = useTranslation()

  // Users who can create projects see the NicolAI CTA
  if (canCreateProject) {
    return <NewProjectCard onClick={onCreateTeam} variant="hero" />
  }

  // Viewers see "contact admin" message
  return (
    <div className="flex flex-col items-center gap-6 py-16">
      {/* Icon */}
      <div className="flex h-20 w-20 items-center justify-center rounded-full border-2 border-border bg-background">
        <Users className="h-9 w-9 text-foreground-muted" />
      </div>

      {/* Text */}
      <div className="flex flex-col items-center gap-2">
        <h2 className="text-xl font-semibold text-foreground">
          {t('dashboard.empty.user.title')}
        </h2>
        <p className="max-w-[300px] text-center text-foreground-muted">
          {t('dashboard.empty.user.description')}
        </p>
      </div>
    </div>
  )
}
